const BRANDS = [
  "Haas",
  "Mazak",
  "DMG Mori",
  "Makino",
  "Okuma",
  "Doosan / DN Solutions",
  "Fanuc",
  "Brother",
  "Citizen",
  "Knuth",
];

export default function Compatibility() {
  return (
    <section
      data-testid="compatibility-section"
      className="bg-[#061226] border-y border-white/10 py-14 lg:py-16 relative overflow-hidden"
    >
      <div className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-[#00B4D8]/50 to-transparent" />
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <h2
          data-testid="compatibility-title"
          className="font-display font-bold text-white text-lg sm:text-xl lg:text-2xl tracking-tight text-center max-w-4xl mx-auto leading-snug mb-10"
        >
          Compatibilidad y especificaciones para las principales marcas de
          centros de maquinado y tornos CNC
        </h2>

        <ul
          data-testid="compatibility-list"
          className="flex flex-wrap items-center justify-center gap-x-3 gap-y-4"
        >
          {BRANDS.map((b, i) => (
            <li key={b} className="flex items-center gap-3">
              {i > 0 && (
                <span className="text-[#00B4D8]/60 font-light select-none" aria-hidden="true">
                  |
                </span>
              )}
              <span
                data-testid={`compatibility-brand-${i + 1}`}
                className="font-mono-accent text-sm lg:text-base uppercase tracking-[0.18em] text-white/85 hover:text-[#00B4D8] transition-colors"
              >
                {b}
              </span>
            </li>
          ))}
        </ul>

        <p
          data-testid="compatibility-note"
          className="text-center text-white/45 text-xs mt-10 font-light"
        >
          *Somos un servicio de ingeniería y mantenimiento independiente
          especializado en dichas marcas.
        </p>
      </div>
    </section>
  );
}
